import React from "react";
import { FAQ, Security, Header, Notice, TestimonialSlider } from "js/new/Components/PageSections";
import App from "js/new/Layouts/AppLayout";
import { Button, Section } from "js/new/Components";
import BuyerFomo from "js/components/pages/CheckoutPage/DropOffDetailsV2/BuyerFomo";

export default function Buyer() {
  const trustItems = [
    {
      head: 'Easy Refunds',
      body: "If the product isn't what was promised, we make refunds simple and hassle-free.",
    },
    {
      head: 'Complete Payment Protection',
      body: 'Your payment is secure and only released when you confirm satisfaction with your purchase.'
    },
    {
      head: 'Fraud Prevention',
      body: "Our service ensures that you won't lose money to untrustworthy sellers. Every transaction is protected.",
    },
    {
      head: 'Dispute Resolution',
      body: "If there's an issue with your order, we're here to mediate and ensure a fair outcome.",
    },
  ];

  const steps = [
    {
      image: 'bag',
      head: '1. Find what you need & pay',
      body: 'Find the product you want to buy on POD SecurePay.',
    },
    {
      image: 'box-tick',
      head: '2. Receive Your item',
      body: "The seller ships the item and you will get it as agreed. You'll have the chance to inspect it once delivered",
    },
    {
      image: 'credit-card',
      head: '3. Automatic Payment Release ',
      body: "After confirming you're happy with your purchase, You will authorize the release of the payment to the seller or POD SecurePay does that for you after 24 hours",
    },
  ]

  const [faqs, setFaqs] = React.useState([]);

  React.useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await fetch('/help-center-data/buyer');
        const data = await response.json();
        setFaqs(data);
      } catch (e) { }
    };

    fetchFaqs();
  }, []);

  return (
    <App hasHeader={false}>

      <div className="mover-bg">
        <Header dark={true} />

        <Section
          pad={false}
          className="tw-grid md:tw-grid-cols-2 tw-items-center tw-justify-between tw-gap-3 md:tw-gap-8 lg:tw-gap-16 lg:tw-flex-row tw-py-16 md:tw-py-32"
        >
          <div className="tw-space-y-8">
            <div className="tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-py-2 tw-px-3 tw-text-white md:tw-inline-flex" style={{background: '#9ca3af40'}}>
              <svg className="size-24px" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 12V18C20 20.21 18.21 22 16 22H8C5.79 22 4 20.21 4 18V12C4 11.45 4.45 11 5 11H6.97C7.52 11 7.97 11.45 7.97 12V15.14C7.97 15.88 8.38 16.56 9.03 16.91C9.32 17.07 9.64 17.15 9.97 17.15C10.35 17.15 10.73 17.04 11.06 16.82L12.01 16.2L12.89 16.79C13.5 17.2 14.28 17.25 14.93 16.9C15.59 16.55 16 15.88 16 15.13V12C16 11.45 16.45 11 17 11H19C19.55 11 20 11.45 20 12Z" fill="white" />
                <path d="M21.5 7V8C21.5 9.1 20.97 10 19.5 10H4.5C2.97 10 2.5 9.1 2.5 8V7C2.5 5.9 2.97 5 4.5 5H19.5C20.97 5 21.5 5.9 21.5 7Z" fill="white" />
                <path d="M11.6427 5.00141H6.12271C5.78271 4.63141 5.79271 4.06141 6.15271 3.70141L7.57271 2.28141C7.94271 1.91141 8.55271 1.91141 8.92271 2.28141L11.6427 5.00141Z" fill="white" />
                <path d="M17.8716 5.00141H12.3516L15.0716 2.28141C15.4416 1.91141 16.0516 1.91141 16.4216 2.28141L17.8416 3.70141C18.2016 4.06141 18.2116 4.63141 17.8716 5.00141Z" fill="white" />
                <path d="M13.9675 11C14.5175 11 14.9675 11.45 14.9675 12V15.13C14.9675 15.93 14.0775 16.41 13.4175 15.96L12.5175 15.36C12.1875 15.14 11.7575 15.14 11.4175 15.36L10.4775 15.98C9.8175 16.42 8.9375 15.94 8.9375 15.15V12C8.9375 11.45 9.3875 11 9.9375 11H13.9675Z" fill="white" />
              </svg>

              <p className="tw-flex-1 tw-text-xs md:tw-text-base tw-font-bold">
                Get <span className="tw-font-bold">N3500</span> towards your shopping today
              </p>
            </div>

            <h1 className="h1-head tw-text-white">
              Buy from any seller and pay after delivery
            </h1>
            <p className="tw-font-semibold tw-text-white">
              Shop with confidence. Your funds are protected until you're 100% satisfied with your purchase to avoid “what I ordered VS what I got”
            </p>

            <Button
              title={'Start Buying & Get N3,500 Today'}
              illustrated
              href={'buyer-signup'}
            />
            <BuyerFomo />
          </div>

          <div></div>
        </Section>
      </div>

      <Notice />

      <Section className="tw-space-y-8 tw-text-black">
        <div>
          <h3 className="tw-text-black">How POD SecurePay Protects Buyers</h3>
          <p>Buy anything with PayOnDelivery.com in 3 simple steps</p>
        </div>

        <div className="tw-grid md:tw-grid-cols-3 tw-gap-4 md:tw-gap-8 lg:tw-gap-16">
          {steps.map((item, index) => (
            <div key={index}>
              <div style={{ border: '1px solid #6d60f6' }} className="tw-rounded-full tw-p-4 md:tw-p-8 tw-mb-2 md:tw-mb-4 tw-inline-block">
                <img loading="lazy" src={`/assets/images/icons/${item.image}.png`} className="from20-32" />
              </div>
              <h5 className="md:tw-mb-4 tw-text-black">{item.head}</h5>
              <p>{item.body}</p>
            </div>
          ))}
        </div>

        <div className="tw-w-full">
          <Button href={'buyer-signup'} className="tw-w-full md:tw-w-auto">Get Started</Button>
        </div>
      </Section>

      <div className="tw-bg-tertiary">
        <Section className="tw-grid md:tw-grid-cols-6 tw-gap-4 md:tw-gap-8 tw-justify-between tw-text-black">
          <div className="md:tw-col-span-4">
            <h3 className="tw-mb-8 tw-text-black">Why Buy with POD Securepay?</h3>

            <div className="tw-grid md:tw-grid-cols-2 tw-gap-8 lg:tw-gap-16">
              {trustItems.map((item, index) => (
                <div key={index}>
                  <h5 className="md:tw-mb-4 tw-text-black">{item.head}</h5>
                  <p>{item.body}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="md:tw-col-span-2">
            <img
              src="/assets/images/pod-shield-secondary.png"
              alt="Safe Transactions"
              height={380}
              width={380}
              className="tw-max-w-full"
              style={{width: '380px', height: '380px'}}
            />
          </div>
        </Section>
      </div>

      <Section>
        <TestimonialSlider
          header="Buyers L❤️ve POD"
          slides={[
            {
              image: '/assets/images/shops/Vodatrox.jpeg',
              name: 'Vodatrox LLC',
              position: 'Buyer',
              content: 'I signed up because I buy bulk orders from my vendor and want to be able to secure my payment until after delivery'
            },
            {
              image: '/assets/images/shops/mimi.png',
              name: 'Mimi\'s world',
              position: 'Buyer',
              content: 'Received my order and I appreciate the happy hour incentive that reduced my delivery charge to just 100 Naira. Thanks so much!'
            },
          ]}
        />
      </Section>

      <FAQ head="Buyers Frequently Ask..." questions={faqs} />

      <Security />
    </App>
  );
}
